/** @format */

import { Injectable } from '@angular/core';
import isbot from 'isbot';

@Injectable({
	providedIn: 'root'
})
export class IsBotService {
	/**
	 * @description Returns boolean value of if user agent string is a bot
	 * Ex: If googlebot, returns true
	 */
	public isBot(userAgentString: string) {
		return isbot(userAgentString);
	}
}
